module.exports = __webpack_public_path__ + "img/CM-SS-25-Mitsubishi-Playful.8103f9d6.jpg";